import axios from 'axios';
import i18n from '@/i18n';
import types from '../../types';
/* eslint-disable */

export default {
  [types.GET_ITEMS]: async (context, payload) => {
    try {
      await axios.get(`items/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('CLEAR_ITEMS');
          context.commit('STORE_ITEMS', res.data.data);
        } else {
          context.commit('STORE_ITEMS', res.data.data);
        }});
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_ITEMS]: ({ commit }, payload) => {
    commit('STORE_ITEMS', payload);
  },
  [types.CLEAR_ITEMS]: (context) => {
    context.commit('CLEAR_ITEMS');
  },
  [types.GET_ITEM]: async (context, payload) => {
    try {
      await axios.get(`items/${payload}/get`).then((res) => {
        context.commit('STORE_ITEM', res.data.data.items);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.ADD_ITEM]: async (context, payload) => {
    try {
      context.commit('STORE_ITEM', {})
      await axios.post('items/create', payload).then((res) => {
        context.commit('STORE_ITEM', res.data.data.item)
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('item_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_ITEM]: async (context, payload) => {
    try {
      await axios.put(`items/${payload.id}/update`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('item_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_ITEMS]: async (context, payload) => {
    try {
      if(payload.type == 'byFilter'){
        // console.log('IZ FILTERA')
        return await axios.post('items', {
          search: payload.search,
          searchTerm: payload.searchTerm,
          total_count: payload.count,
        });
      } else {
        // console.log('IZ IDJEVA')
        return await axios.delete(`items/0/delete?ids=[${payload.ids}]`);
      }
    } catch (err) {
      console.error(err);
    }
  },
  [types.UPLOAD_ITEM_IMAGE]: async (context, payload) => {
    try {
      var formData = new FormData();
      formData.append('image', payload.file);
      return await axios.post(`items/${payload.id}/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        return res;
      });
    } catch (err) {
      console.error(err);
    }
  },
};
